export default {
  // Data statistics
  totalData: "Total {count} records",

  // Loading
  loading: "Loading...",

  // Table columns
  operation: "Operation",
  client: "Client",
  state: "State",
  updateTime: "Update Time",
  paymentMethod: "Payment Method",
  paymentDetail: "Payment Detail",
  bankCard: "Bank Card/Account",
  bankBranch: "Bank Branch",
  bankName: "Bank Name",

  // Empty state
  noPaymentData:
    "No payment method record data parsed from current investigation file",

  // Download
  downloadDetails: "Download Details",
  downloadFileName: "Data Details",
};
